export default {
  '***': {
    '***': [
      {
        id: 100,
        label: 'Internet',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [101, 102, 103],
        tooltip: ''
      },
      {
        id: 101,
        label: 'Entry (<400 Mbps)',
        selected: 0,
        collapse: 0,
        parent: 100,
        children: [],
        tooltip: ''
      },
      {
        id: 102,
        label: 'Mid (400 - <800 Mbps)',
        selected: 0,
        collapse: 0,
        parent: 100,
        children: [],
        tooltip: ''
      },
      {
        id: 103,
        label: 'High (800+ Mbps)',
        selected: 0,
        collapse: 0,
        parent: 100,
        children: [],
        tooltip: ''
      },
      {
        id: 200,
        label: 'Mobile',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [201, 202, 203, 204],
        tooltip: ''
      },
      {
        id: 201,
        label: 'Unlimited Intro (20 GB)',
        selected: 0,
        collapse: 0,
        parent: 200,
        children: [],
        tooltip: ''
      },
      {
        id: 202,
        label: 'Unlimited Plus (30 GB)',
        selected: 0,
        collapse: 0,
        parent: 200,
        children: [],
        tooltip: ''
      },
      {
        id: 203,
        label: 'Unlimited Premium (50 GB)',
        selected: 0,
        collapse: 0,
        parent: 200,
        children: [],
        tooltip: ''
      },
      {
        id: 204,
        label: 'By the Gig (1GB)',
        selected: 0,
        collapse: 0,
        parent: 200,
        children: [],
        tooltip: ''
      },
      {
        id: 300,
        label: 'Internet Led Converged',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [301, 302, 303],
        tooltip: ''
      },
      {
        id: 301,
        label: 'Entry (<400 Mbps)',
        selected: 0,
        collapse: 0,
        parent: 300,
        children: [],
        tooltip: ''
      },
      {
        id: 302,
        label: 'Mid (400 - <800 Mbps)',
        selected: 0,
        collapse: 0,
        parent: 300,
        children: [],
        tooltip: ''
      },
      {
        id: 303,
        label: 'High (800+ Mbps)',
        selected: 0,
        collapse: 0,
        parent: 300,
        children: [],
        tooltip: ''
      },
      {
        id: 500,
        label: 'Mobile Led Converged',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [501, 502, 503, 504],
        tooltip: ''
      },
      {
        id: 501,
        label: 'Unlimited Intro (20 GB)',
        selected: 0,
        collapse: 0,
        parent: 500,
        children: [],
        tooltip: ''
      },
      {
        id: 502,
        label: 'Unlimited Plus (30 GB)',
        selected: 0,
        collapse: 0,
        parent: 500,
        children: [],
        tooltip: ''
      },
      {
        id: 503,
        label: 'Unlimited Premium (50 GB)',
        selected: 0,
        collapse: 0,
        parent: 500,
        children: [],
        tooltip: ''
      },
      {
        id: 504,
        label: 'By the Gig (1GB)',
        selected: 0,
        collapse: 0,
        parent: 500,
        children: [],
        tooltip: ''
      },
      {
        id: 600,
        label: '3 for 1',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [601, 602, 603],
        tooltip: ''
      },
      {
        id: 601,
        label: '3 for 1',
        selected: 0,
        collapse: 0,
        parent: 600,
        children: [],
        tooltip: ''
      },
      {
        id: 602,
        label: '3P',
        selected: 0,
        collapse: 0,
        parent: 600,
        children: [],
        tooltip: ''
      },
      {
        id: 603,
        label: 'Other 3P',
        selected: 0,
        collapse: 0,
        parent: 600,
        children: [],
        tooltip: ''
      },
      {
        id: 700,
        label: 'National Promotions',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [710, 720, 730, 740, 750, 760],
        tooltip: ''
      },
      {
        id: 710,
        label: 'Go-to-Market (GTM)',
        selected: 0,
        collapse: 0,
        parent: 700,
        children: [],
        tooltip: ''
      },
      {
        id: 720,
        label: 'Black Friday',
        selected: 0,
        collapse: 0,
        parent: 700,
        children: [],
        tooltip: ''
      },
      {
        id: 730,
        label: 'Spring Sale',
        selected: 0,
        collapse: 0,
        parent: 700,
        children: [],
        tooltip: ''
      },
      {
        id: 740,
        label: 'Back to School',
        selected: 0,
        collapse: 0,
        parent: 700,
        children: [],
        tooltip: ''
      },
      {
        id: 750,
        label: 'Hello 2023',
        selected: 0,
        collapse: 0,
        parent: 700,
        children: [],
        tooltip: ''
      },
      {
        id: 760,
        label: `Q4 PAR "Holiday Sale"`,
        selected: 0,
        collapse: 0,
        parent: 700,
        children: [],
        tooltip: ''
      },
      {
        id: 800,
        label: 'Content Offer',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813,
          814, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825],
        tooltip: ''
      },
      {
        id: 801,
        label: 'Apple Music',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 802,
        label: 'Apple TV',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 803,
        label: 'CrunchyRoll',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 804,
        label: 'Discovery+',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },

      {
        id: 805,
        label: 'Disney+',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 806,
        label: 'ESPN+',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 807,
        label: 'HBOMax',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 808,
        label: 'Hulu',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 809,
        label: 'Hulu with Live TV',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 810,
        label: 'MAX',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 811,
        label: 'MLB Extra Innings',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 812,
        label: 'MLS Season Pass',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 813,
        label: 'NBA League Pass',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 814,
        label: 'Netflix',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 815,
        label: 'NFL Redzone',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 816,
        label: 'NFL Sunday Ticket',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 817,
        label: 'NHL Center Ice',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 818,
        label: 'Pandora',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 819,
        label: 'Paramount+',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 820,
        label: 'Peacock',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 821,
        label: 'Showtime',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },

      {
        id: 822,
        label: 'SlingTV',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 823,
        label: 'Spotify',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 824,
        label: 'Vix +',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },
      {
        id: 825,
        label: 'YouTube TV',
        selected: 0,
        collapse: 0,
        parent: 800,
        children: [],
        tooltip: ''
      },


      {
        id: 900,
        label: 'Streaming Device',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [910],
        tooltip: ''
      },
      {
        id: 910,
        label: '4K Streaming Box',
        selected: 0,
        collapse: 0,
        parent: 900,
        children: [],
        tooltip: ''
      },
      {
        id: 1000,
        label: 'Streaming/Content Bundle',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [1010],
        tooltip: ''
      },
      {
        id: 1010,
        label: 'Yes',
        selected: 0,
        collapse: 0,
        parent: 1000,
        children: [],
        tooltip: ''
      },
      {
        id: 2000,
        label: 'Device Free / Subsidy',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [2010, 2020, 2030],
        tooltip: ''
      },
      {
        id: 2010,
        label: 'Discounted Mobile Device',
        selected: 0,
        collapse: 0,
        parent: 2000,
        children: [],
        tooltip: ''
      },
      {
        id: 2020,
        label: 'Free Mobile Device',
        selected: 0,
        collapse: 0,
        parent: 2000,
        children: [],
        tooltip: ''
      },
      {
        id: 2030,
        label: 'Premium Giveaway',
        selected: 0,
        collapse: 0,
        parent: 2000,
        children: [],
        tooltip: ''
      },
      {
        id: 3000,
        label: 'Gift Card',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [3010],
        tooltip: ''
      },
      {
        id: 3010,
        label: 'Yes',
        selected: 0,
        collapse: 0,
        parent: 3000,
        children: [],
        tooltip: ''
      },
      {
        id: 4000,
        label: 'Equipment Setup',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [4010, 4020, 4030],
        tooltip: ''
      },
      {
        id: 4010,
        label: 'Included',
        selected: 0,
        collapse: 0,
        parent: 4000,
        children: [],
        tooltip: ''
      },
      {
        id: 4020,
        label: 'Required',
        selected: 0,
        collapse: 0,
        parent: 4000,
        children: [],
        tooltip: ''
      },
      {
        id: 4030,
        label: 'Optional',
        selected: 0,
        collapse: 0,
        parent: 4000,
        children: [],
        tooltip: ''
      },
      {
        id: 5000,
        label: 'Price Structure',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [5010, 5020],
        tooltip: ''
      },
      {
        id: 5010,
        label: 'Promotion',
        selected: 0,
        collapse: 0,
        parent: 5000,
        children: [],
        tooltip: ''
      },
      {
        id: 5020,
        label: 'EDP',
        selected: 0,
        collapse: 0,
        parent: 5000,
        children: [],
        tooltip: ''
      },
      {
        id: 6000,
        label: 'Contract',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [6010, 6020, 6030, 6040],
        tooltip: ''
      },
      {
        id: 6010,
        label: 'No Contract',
        selected: 0,
        collapse: 0,
        parent: 6000,
        children: [],
        tooltip: ''
      },
      {
        id: 6020,
        label: '12 Month',
        selected: 0,
        collapse: 0,
        parent: 6000,
        children: [],
        tooltip: ''
      },
      {
        id: 6030,
        label: '24 Month',
        selected: 0,
        collapse: 0,
        parent: 6000,
        children: [],
        tooltip: ''
      },
      {
        id: 6040,
        label: '>=36 Months',
        selected: 0,
        collapse: 0,
        parent: 6000,
        children: [],
        tooltip: ''
      },
      {
        id: 7000,
        label: 'Price Guarantee',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [7010, 7020, 7030],
        tooltip: ''
      },
      {
        id: 7010,
        label: '12 Month',
        selected: 0,
        collapse: 0,
        parent: 7000,
        children: [],
        tooltip: ''
      },
      {
        id: 7020,
        label: '24 Month',
        selected: 0,
        collapse: 0,
        parent: 7000,
        children: [],
        tooltip: ''
      },
      {
        id: 7030,
        label: '>=36 Months',
        selected: 0,
        collapse: 0,
        parent: 7000,
        children: [],
        tooltip: ''
      },
      {
        id: 8000,
        label: 'Price Lock',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [8010, 8020, 8030],
        tooltip: ''
      },
      {
        id: 8010,
        label: '12 Month',
        selected: 0,
        collapse: 0,
        parent: 8000,
        children: [],
        tooltip: ''
      },
      {
        id: 8020,
        label: '24 Month',
        selected: 0,
        collapse: 0,
        parent: 8000,
        children: [],
        tooltip: ''
      },
      {
        id: 8030,
        label: '>=36 Months',
        selected: 0,
        collapse: 0,
        parent: 8000,
        children: [],
        tooltip: ''
      },
      {
        id: 9000,
        label: 'Offer Price',
        selected: 0,
        collapse: 0,
        parent: 0,
        children: [9010, 9020, 9030, 9040],
        tooltip: ''
      },
      {
        id: 9010,
        label: 'Under $40',
        selected: 0,
        collapse: 0,
        parent: 9000,
        children: [],
        tooltip: ''
      },
      {
        id: 9020,
        label: '$40 to $49.99',
        selected: 0,
        collapse: 0,
        parent: 9000,
        children: [],
        tooltip: ''
      },
      {
        id: 9030,
        label: '$50 to $59.99',
        selected: 0,
        collapse: 0,
        parent: 9000,
        children: [],
        tooltip: ''
      },
      {
        id: 9040,
        label: '$60 or more',
        selected: 0,
        collapse: 0,
        parent: 9000,
        children: [],
        tooltip: ''
      }

    ]
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/selection/Search/tagHierarchy.js